import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Home from './Home';
import LevelPage from './LevelPage';
import TopicPage from './TopicPage';
import NotesPage from './NotesPage';
import Syllabus from './Syllabus';
import Privacy from './Privacy';
import NotFound from './NotFound';
import Footer from './Footer';
import { initAnalytics, trackPageView } from './analytics';

// Routes change without a page reload, so tell Analytics about each one.
const PageViews = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    // Each page sets document.title in its own effect, and those run after
    // this one (this component is an earlier sibling). Wait a tick so the
    // page_view carries the new page's title rather than the previous one.
    const t = setTimeout(() => trackPageView(pathname), 0);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
};

function App() {

  useEffect(() => { initAnalytics(); }, []);

  return (
    <Router>
      <PageViews />
      <div className="App">
        <Navbar />
        <div className="content">
          <Switch>
            <Route exact path="/"><Home /></Route>
            <Route exact path="/syllabus"><Syllabus /></Route>
            <Route exact path="/privacy"><Privacy /></Route>

            <Route exact path="/S3"><LevelPage level="s3" /></Route>
            <Route exact path="/S4"><LevelPage level="s4" /></Route>
            <Route exact path="/S5"><LevelPage level="s5" /></Route>
            <Route exact path="/S6"><LevelPage level="s6" /></Route>

            <Route exact path="/S3/notes"><NotesPage level="s3" /></Route>
            <Route exact path="/S4/notes"><NotesPage level="s4" /></Route>
            <Route exact path="/S5/notes"><NotesPage level="s5" /></Route>
            <Route exact path="/S6/notes"><NotesPage level="s6" /></Route>

            <Route path="/S3/:slug"><TopicPage level="s3" /></Route>
            <Route path="/S4/:slug"><TopicPage level="s4" /></Route>
            <Route path="/S5/:slug"><TopicPage level="s5" /></Route>
            <Route path="/S6/:slug"><TopicPage level="s6" /></Route>

            <Route path="*"><NotFound /></Route>
          </Switch>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
